// External
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import SinglePage from "./SinglePage";
import SingleQuestion from "./SingleQuestion";
import { initAnswers } from "../../store/actions/answers";
import { changeNavigation } from "../../store/actions/navigation";
import { useDesktop } from "../../utils/useDesktop";

import "./Questionaire.scss";

const Questionaire = (props) => {
	const dispatch = useDispatch();
	const questions = useSelector((state) => state.questions.questions);
	const answersReady = useSelector((state) => state.answers.answersReady);

	useEffect(() => {
		// call this action only onetime to initialize the form state in store
		dispatch(initAnswers({ questions }));
		// call this action to select the correct question in store
		const question = questions.find(
			(question) => String(question.id) === props.questionId,
		);
		if (question) {
			dispatch(
				changeNavigation({
					currentQuestion: question.id,
					surveyStep: question.survey_step,
				}),
			);
		}
	// don't call this hook whenever the prop.questionId changes
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dispatch, questions]);

	const isDesktop = useDesktop();

	if (!answersReady) return null;

	return isDesktop ? <SinglePage /> : <SingleQuestion />;
};

// Export
export default Questionaire;
